import styled, { css } from 'styled-components'
import type { StyledSvgComponent } from '../../types/svg'
import { getBasePath } from '../../utils/miscellaneous-utils'
import FullStar from '../../assets/icons/star.svg'
import Offer from '../../assets/icons/offer-badge.svg'
import FreeCancellation from '../../assets/icons/free-cancellation-shield.svg'
import { GreenTickIcon } from '../common/icons'
import ExternalLink from './external-link'

const checkBoxUrl = `url(${getBasePath('/assets/icons/white-check.svg')})`

export const WishlistIconContainer = styled.div`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
`

export const FavoriteButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 3.5rem;
    height: 3.5rem;
    background: radial-gradient(100% 100% at 100% 0%, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ObjectTopRecommendationPill = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0rem;
    right: 0rem;
    width: 4.5rem;
    height: 3.5rem;
    background: radial-gradient(100% 100% at 100% 100%, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
    justify-content: center;
`

export const TopRecommendationWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: ${theme.typography.font.size.xxSmall};
        line-height: ${theme.typography.font.size.xSmall};
        color: #ffffff;
        position: absolute;
        bottom: 0.5rem;
        right: 0.5rem;
    `,
)

export const PartnerLogoContainer = styled.div<{ $partnerName: string }>(
    ({ theme, $partnerName }) => css`
        position: absolute;
        top: ${theme.spacing.small};
        right: ${theme.spacing.small};
        background-color: #fff;
        border-radius: ${$partnerName === 'holidu'
            ? theme.typography.border.radius.medium
            : theme.typography.border.radius.xSmall};
        padding: ${$partnerName === 'holidu'
            ? theme.spacing.xxSmall
            : `${theme.spacing.xxSmall} ${theme.spacing.xSmall}`};
        display: flex;
        align-items: center;
        justify-content: center;
    `,
)

export const PartnerLogo = styled.img<{ $partnerName: string }>(
    ({ $partnerName }) => `
        width: ${$partnerName === 'holidu' ? '4.5rem' : '3rem'};
        height: auto;
        object-fit: contain;
    `,
)

export const CheckBox = styled.div`
    width: 1.5rem;
    height: 1.5rem;
`

export const CheckBoxLabel = styled.label(
    ({ theme }) => css`
        padding: ${theme.spacing.xSmall};
        display: inline-block;
        position: relative;
        cursor: pointer;
        width: 100%;
        height: 100%;
        outline: 0;
        background-color: white;
        border-radius: 0.3rem;
    `,
)

export const InputCheckbox = styled.input`
    &:checked + ${CheckBoxLabel} {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: ${props => props.theme.colors.tfwBlack99} ${checkBoxUrl} no-repeat center;
        background-size: 1rem;
    }

    display: none;
`

export const InformationWrapper = styled.div`
    display: flex;
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    z-index: 20;
    width: 1.5rem;
    height: 1.5rem;
`

export const LocationContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xxSmall};
    `,
)

export const TraumTagIconStyled = styled.svg`
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
`

export const TraumTagImageStyled = styled.img`
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    object-fit: contain;
`

export const PopularChoiceTagContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xxSmall};
    `,
)

export const BottomTraumTagImage = styled.img`
    width: 1.5rem;
    height: 1.5rem;
    object-fit: contain;
`

export const BottomTraumTagText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: 1.375rem;
        font-weight: 600;
        color: #8f6408;
    `,
)

export const OfferWrapper = styled.div``

export const OfferIcon = styled(Offer as StyledSvgComponent)(
    ({ theme }) => css`
        width: 1rem;
        height: 1rem;
        margin-right: ${theme.spacing.xxSmall};
    `,
)

export const FullStarIcon = styled(FullStar as StyledSvgComponent)`
    width: 1rem;
    height: 1rem;
    margin-right: 0.312rem;
    flex-shrink: 0;
`

export const QuickResponderTag = styled.div(
    ({ theme }) => css`
        display: inline-flex;
        align-items: center;
        color: #0d7c4f;
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
    `,
)

export const StyledFastResponderIcon = styled(GreenTickIcon)(
    ({ theme }) => css`
        width: 0.75rem;
        height: 0.75rem;
        margin-right: ${theme.spacing.xSmall};
        vertical-align: middle;
    `,
)

export const DTVStarContainer = styled.div`
    display: flex;
`

export const DTVRatingText = styled.span(
    ({ theme }) => css`
        display: flex;
        flex-shrink: 0;
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
        color: #282828;
    `,
)

export const DTVImage = styled.img(
    ({ theme }) => css`
        width: 2rem;
        height: 0.6875rem;
        object-fit: contain;
        margin-left: ${theme.spacing.xxSmall};
    `,
)

export const BaseTooltipContainer = styled.div(
    ({ theme }) => css`
        position: absolute;
        bottom: 150%;
        left: 50%;
        transform: translateX(-50%);
        background-color: #333;
        color: white;
        padding: ${theme.spacing.xSmall};
        border-radius: 4px;
        font-size: ${theme.typography.font.size.xSmall};
        white-space: normal;
        opacity: 0;
        visibility: hidden;
        transition:
            opacity 0.2s,
            visibility 0.2s;
        z-index: 10;
        width: max-content;
        max-width: 200px;
        text-align: center;

        &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #333 transparent transparent transparent;
        }
    `,
)

export const DTVContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    &:hover ${BaseTooltipContainer} {
        opacity: 1;
        visibility: visible;
    }
`

export const BaseDTVLabel = styled.span(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
        color: #6f6f6f;
        margin-left: ${theme.spacing.xxSmall};
    `,
)

export const BaseBookingHighlights = styled.div(
    ({ theme }) => `
        display: flex;
        margin-top: ${theme.spacing.xSmall};
        gap: ${theme.spacing.xxSmall} ${theme.spacing.medium};
        flex-wrap: wrap;
    `,
)

export const BaseLocationText = styled.span(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
        color: #6c6c6c;
        font-weight: 400;
    `,
)
export const BasePopularChoiceTagText = styled.span(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
        font-weight: 600;
        color: #8f6408;
    `,
)

export const BaseTraumTagLabel = styled.span(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
        font-weight: 400;
        color: #282828;
        white-space: nowrap;
    `,
)

export const BaseRatingText = styled.span(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: 1.375rem;
        color: #282828;
    `,
)

export const BaseNextImageContainer = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
`

export const BaseSeoHref = styled.a`
    display: flex;
    font: inherit;
    text-decoration: none;
`

export const BaseOfferBadge = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        width: fit-content;
        min-width: 10.25rem;
        background: linear-gradient(90deg, #d2faea 0%, #ffffff 100%);
        padding: ${theme.spacing.xxSmall} ${theme.spacing.xSmall};
        border-radius: ${theme.typography.border.radius.xLarge};
    `,
)

export const BaseOfferText = styled.span(
    ({ theme }) => `
        color: #0d7c4f;
        font-size: ${theme.typography.font.size.small};
        line-height: 1.375rem;
        font-weight: 400;
    `,
)

export const BaseFreeCancellationContainer = styled.div(
    ({ theme }) => `
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xxSmall};
    `,
)

export const BaseFreeCancellationText = styled.span(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        font-weight: 400;
        line-height: 1.375rem;
        color: #282828;
    `,
)

export const BaseFreeCancellationIcon = styled(FreeCancellation as StyledSvgComponent)`
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    & path[fill^='url'] {
        fill: #0d7c4f;
    }
`

export const PropertyTitleLink = styled(ExternalLink)`
    display: inline;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font: inherit;
    text-decoration: none;
`
